import React from "react";
import {
  FaFacebookF,
  FaPinterestP,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";
import { IoMailOpenOutline } from "react-icons/io5";
import { FaXTwitter } from "react-icons/fa6";

const TopBar = () => {
  return (
    <div className="bg-black text-white py-12 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-4">
        <IoMailOpenOutline className="" size={42} />
        <div>
          <h2 className="text-2xl font-semibold">Subscribe our Newsletter</h2>
          <p className="text-lg text-gray-400">
            Stay updated with our latest news, offers, and product updates.
          </p>
        </div>
      </div>

      <div className="flex items-center w-full md:w-auto bg-[#2c2c2c] rounded-full overflow-hidden">
        <input
          type="email"
          placeholder="Your email address"
          className="bg-transparent text-white px-6 py-3 outline-none w-full md:w-80 placeholder:text-gray-400"
        />
        <button className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-3 rounded-full font-semibold transition">
          Subscribe
        </button>
      </div>

      <div className="flex gap-6 text-xl">
        <a
          href="https://www.facebook.com/Bricknbar/"
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-full flex items-center justify-center hover:bg-green-500 transition"
        >
          <FaFacebookF size={24} className=" hover:text-white" />
        </a>

        <a
          href="https://x.com/BricknBar"
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-full flex items-center justify-center hover:bg-green-500  transition"
        >
          <FaXTwitter size={24} className=" hover:text-white" />
        </a>

        <a
          href="https://www.youtube.com/@BricknBar"
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-full flex items-center justify-center hover:bg-green-500  transition"
        >
          <FaYoutube size={24} className=" hover:text-white" />
        </a>

        <a
          href="https://in.pinterest.com/brickandbar/_pins/"
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-full flex items-center justify-center hover:bg-green-500  transition"
        >
          <FaPinterestP size={24} className=" hover:text-white" />
        </a>

        <a
          href="https://www.instagram.com/bricknbar/"
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-full flex items-center justify-center hover:bg-green-500  transition"
        >
          <FaInstagram size={24} className=" hover:text-white" />
        </a>
      </div>
    </div>
  );
};

export default TopBar;
